"use client";

import Table from "@core/components/table";
import { withdrawalColumns } from "./withdrawal-columns";
import WidgetCard from "@core/components/cards/widget-card";
// import { AllTransactionsData, Transaction } from "@/data/all-transactions";
import { useTanStackTable } from "@core/components/table/custom/use-TanStack-Table";
import TablePagination from "@core/components/table/pagination";
import cn from "@core/utils/class-names";
import Filters from "./withdrawal-filters";
import { Withdrawal } from "packages/app/src/types";
import React from "react";

interface WithdarawalProps {
  withdrawals: Withdrawal[];
  isLoading: boolean;
  className?: string;
  error: Error | null;
}
export default function WithDrawalTable({
  className,
  withdrawals,
  isLoading,
  error,
}: WithdarawalProps) {
  const { table, setData } = useTanStackTable<Withdrawal>({
    tableData: withdrawals,
    columnConfig: withdrawalColumns,
    options: {
      initialState: {
        pagination: {
          pageIndex: 0,
          pageSize: 5,
        },
      },
      meta: {
        handleDeleteRow: (row) => {
          setData((prev) => prev.filter((r) => r.id !== row.id));
        },
      },
      enableColumnResizing: false,
    },
  });

  React.useEffect(() => {
    setData(withdrawals);
  }, [withdrawals, setData]);

  if (isLoading)
    return (
      <div className="col-span-full h-60 flex justify-center items-center text-[16px] font-semibold">
        <p className="text-center">Loading withdrawals...</p>
      </div>
    );
  if (error) return <div className="text-red-600">Error: {error.message}</div>;

  return (
    <WidgetCard
      className={cn("p-0 lg:p-0", className)}
      title="Withdrawals"
      titleClassName="w-[19ch]"
      actionClassName="w-full ps-0 items-center"
      headerClassName="mb-6 items-start flex-col @[57rem]:flex-row @[57rem]:items-center px-5 pt-5 lg:pt-7 lg:px-7"
      action={<Filters table={table} />}
    >
      <Table table={table} variant="modern" />
      <TablePagination table={table} className="p-4" />
    </WidgetCard>
  );
}
